import { createStyles } from "@mantine/core"

export const useStyles = createStyles((theme) => ({
    root: {
        [theme.fn.largerThan("xs")]: {
            maxWidth: 320,
        },

        fontSize: theme.fontSizes.sm,
        justifyContent: "flex-start",
        padding: "0 0 0 8px",
        textTransform: "none",
        backgroundColor: theme.colors.gray[1],
    },

    inner: {
        color: theme.colors.gray[9],
    },
    leftSection: {
        marginRight: 4,
    },
    rightSection: {
        marginLeft: 4,
    },
}))
